class CategoryAjaxDropdown {
	constructor(dropdown, postsContainer, hasPagination = false) {
		const thisObject = this;

		this.dropdown = dropdown;
		this.postContainer = postsContainer;
		this.hasPagination = hasPagination;
		this.pageNumber = window.mainLocalize.currentPage;

		this.dropdown.on('change', function () {
			thisObject.selectCategory($(this));
		});

		if (thisObject.hasPagination) {
			thisObject.paginationAjax();
		}
	}

	selectCategory(dropdown) {
		const thisObject = this;

		dropdown.prop('disabled', true);

		$.ajax({
			url: window.mainLocalize.ajaxUrl,
			data: {
				'action': 'change_category',
				'category': +dropdown.val(),
			},
			type: 'POST',
			beforeSend: function () {
				thisObject.postContainer.css('opacity', '.5');
			},
			success: function (data) {
				if (data) {
					thisObject.postContainer.html(data).css('opacity', '');
				}

				dropdown.prop('disabled', false);

				if (thisObject.hasPagination) thisObject.paginationAjax();
			},
		});
	}

	paginationAjax() {
		const thisObject = this;

		const paginationBtns = this.postContainer.find('a.page-numbers');

		if (paginationBtns.length) {
			paginationBtns.on('click', function (e) {
				e.preventDefault();

				paginationBtns.css('pointer-events', 'none');

				if ($(this).hasClass('next')) {
					thisObject.pageNumber++;
				} else if ($(this).hasClass('prev')) {
					thisObject.pageNumber--;
				} else {
					thisObject.pageNumber = +$(this).html();
				}

				$.ajax({
					url: window.mainLocalize.ajaxUrl,
					data: {
						'action': 'change_category_page',
						'category': +thisObject.dropdown.val(),
						'pageNumber': thisObject.pageNumber,
					},
					type: 'POST',
					beforeSend: function () {
						thisObject.postContainer.css('opacity', '.5');
					},
					success: function (data) {
						if (data) {
							thisObject.postContainer.html(data).css('opacity', '');

							thisObject.paginationAjax();
						}
					},
				});
			});
		}
	}
}

export default CategoryAjaxDropdown;



// WEBPACK FOOTER //
// ./scripts/modules/category-ajax-dropdown.js